import React from 'react';
import { Badge } from 'react-bootstrap';
import { getPaymentDisplayForOrder, hasFulfillmentPaymentMismatch } from '../../helper/order_helper';

export default function OrderPaymentBadges({ order, compact = false }) {
    const display = getPaymentDisplayForOrder(order);
    const mismatch = hasFulfillmentPaymentMismatch(order);

    return (
        <div className={compact ? '' : 'order-payment-badges'}>
            <Badge bg="secondary" className="mb-1">{order?.paymentMethod || '—'}</Badge>
            <br />
            <Badge
                bg={display.statusBadge}
                style={{ fontSize: compact ? '10px' : '11px' }}
                title={display.title || undefined}
            >
                {display.statusLabel}
            </Badge>
            {mismatch && (
                <>
                    <br />
                    <Badge bg="danger" style={{ fontSize: '9px', marginTop: '2px' }} title="Fulfillment advanced but Cashfree payment is still unverified">
                        <i className="ri-error-warning-line me-1" />
                        Ship risk
                    </Badge>
                </>
            )}
        </div>
    );
}
